import styled from 'react-emotion';

const TextPlated = styled.span`
  text-shadow: 0px 0px 0 ${props => props.theme.colors.cool.ink}, 1px 0px 0 ${props => props.theme.colors.cool.ink},
    0px 1px 0 ${props => props.theme.colors.cool.ink}, 1px 1px 0 ${props => props.theme.colors.cool.ink};
`;

export default TextPlated;



// WEBPACK FOOTER //
// ./src/components/TextPlated.jsx